import { Button, Card, Divider, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import Box from "@mui/material/Box";
import CalenderIcon from "../../../assets/Icon/CalenderIcon";
import ErrorIcon from "../../../assets/Icon/ErroIcon";
import { LocationOn } from "@mui/icons-material";
import { isMobileDeviceCheck } from "../../../utils";
import { ReservationStatus } from "../../../pages/reservationFlow/reservationDetails";
import {
  convertUtcToYard,
  getTimeZone,
  getMonthlyToDate,
  MOMENT_CONSTANTS,
} from "../../../utils/momentUtils";
import { useTranslation } from "react-i18next";
import ExitIcon from "../../../assets/Icon/ExitIcon";
import EnterIcon from "../../../assets/Icon/EnterIcon";
import storePersist, { localConstant } from "../../../services/localStorage";
import { useMemo } from "react";
// import Error

const InGateButtonStyles = {
  backgroundColor: "#fff",
  borderColor: "#8A8886",
  color: "#605E5C",
  width: "100%",
  height: "35px",
};

const InGateTextColor = "primary.main";

const GateActions = ({ openGate, gates, enabled }) => {
  const noOfItems = 2;
  const items = [];
  for (let i = 0; i < gates?.length; i += noOfItems) {
    const gate1_dir = gates?.[i]?.equipment_direction;
    const gate2_dir = gates?.[i + 1]?.equipment_direction;
    if (i % noOfItems === 0) {
      items.push(
        <Stack
          spacing={1}
          key={i}
          direction="row"
          sx={{ marginBottom: 1, marginTop: 1 }}
        >
          {enabled && gates?.[i]?.equipment_id && (
            <Button
              sx={{ mt: 2, mb: 2, mr: 1 }}
              size="large"
              variant="outlined"
              type="submit"
              style={
                gate1_dir === "IN" ? InGateButtonStyles : InGateButtonStyles
              }
              endIcon={
                gate1_dir === "IN" ? (
                  <EnterIcon color="#1D5AB9" width="28px" height="28px" />
                ) : (
                  <ExitIcon color="#1D5AB9" width="28px" height="28px" />
                )
              }
              onClick={(event) => {
                event.stopPropagation();
                openGate(gates?.[i]);
              }}
            >
              <Typography
                variant="subtitle2"
                color={InGateTextColor}
                sx={{ whiteSpace: "nowrap", display: "inline-block" }}
              >
                {gates?.[i]?.equipment_name}
              </Typography>
            </Button>
          )}
          {enabled && gates?.[i + 1]?.equipment_id && (
            <Button
              sx={{ mt: 2, mb: 2, ml: 1 }}
              size="large"
              variant="outlined"
              type="submit"
              style={
                gate2_dir === "IN" ? InGateButtonStyles : InGateButtonStyles
              }
              endIcon={
                gate2_dir === "IN" ? (
                  <EnterIcon color="#1D5AB9" width="28px" height="28px" />
                ) : (
                  <ExitIcon color="#1D5AB9" width="28px" height="28px" />
                )
              }
              onClick={(event) => {
                event.stopPropagation();
                openGate(gates?.[i + 1]);
              }}
            >
              <Typography
                variant="subtitle2"
                color={InGateTextColor}
                sx={{ whiteSpace: "nowrap", display: "inline-block" }}
              >
                {gates?.[i + 1]?.equipment_name}
              </Typography>
            </Button>
          )}
        </Stack>,
      );
    }
  }
  if (!items?.length) {
    return null;
  }
  return items;
};

const UpcomingCard = (props) => {
  const { t } = useTranslation();
  const currentUserType = storePersist.get(localConstant.USER_PROFILE);
  const {
    total_spots,
    reservation_id,
    location_city,
    reservation_from_date,
    reservation_to_date,
    reservation_status,
    location_id,
    timezone,
    payment_status_code,
    spot_number_list = [],
  } = props?.data;

  // get list of gate for selected reservation location
  const gates =
    props?.gateList?.length > 0 &&
    props?.gateList.filter((d) => d.location_id === location_id);

  const from_date = convertUtcToYard({
    date: reservation_from_date,
    enableFormat: true,
    timeZone: timezone,
    dateFormat: reservation_to_date
      ? undefined
      : MOMENT_CONSTANTS.date.fullMonthDay,
  });
  const to_date = reservation_to_date
    ? convertUtcToYard({
        date: reservation_to_date,
        enableFormat: true,
        timeZone: timezone,
      })
    : getMonthlyToDate({ date: reservation_from_date, timeZone: timezone });

  const formatedtedDate = reservation_to_date
    ? `${from_date} to ${to_date} ${getTimeZone(timezone)}`
    : `${from_date} ${getTimeZone(timezone)}`;

  const total_spots_available =
    total_spots > 1
      ? `${total_spots} ${t("components.upcomingCard.text04")} `
      : `${total_spots} spot reserved`;

  const getSpotOrder = useMemo(() => {
    if (spot_number_list.length <= 0) return [""];
    if (spot_number_list.length === 1) return [spot_number_list[0]];
    spot_number_list.sort((a, b) => a - b);
    let segregatedSpots = [];
    let currentSpot = {
      spot: spot_number_list[0],
      spotIdx: 0,
    };
    let i;
    for (i = 1; i < spot_number_list.length; i++) {
      if (spot_number_list[i - 1] === spot_number_list[i] - 1) continue;
      else {
        if (currentSpot.spotIdx === i - 1)
          segregatedSpots.push(spot_number_list[i - 1]);
        else {
          if (currentSpot.spot === spot_number_list[i - 1])
            segregatedSpots.push(spot_number_list[i - 1]);
          else
            segregatedSpots.push(
              `${currentSpot.spot}-${spot_number_list[i - 1]}`,
            );
        }
        currentSpot = {
          spot: spot_number_list[i],
          potIdx: i,
        };
      }
    }
    if (i === spot_number_list.length)
      if (currentSpot.spot === spot_number_list[i - 1])
        segregatedSpots.push(spot_number_list[i - 1]);
      else
        segregatedSpots.push(
          `${currentSpot.spot}-${spot_number_list[spot_number_list.length - 1]}`,
        );
    return segregatedSpots;
  }, [spot_number_list]);
  return (
    <Card
      style={{ cursor: "pointer" }}
      sx={{ p: 1, width: 1, maxWidth: 430, mb: 1 }}
    >
      <Box display="flex" justifyContent="space-between">
        <Box
          width={"75%"}
          onClick={() => {
            props?.onPress(gates);
          }}
        >
          <Stack
            alignItems="center"
            justifyContent={"space-between"}
            direction="row"
            spacing={0}
          >
            <Typography variant="subtitle2" color={"#3A4454"}>
              {`${t("components.upcomingCard.text01")} ${reservation_id} - ${
                location_city ? location_city : ""
              }`}
            </Typography>
          </Stack>

          <Stack
            justifyContent={"space-between"}
            direction="column"
            spacing={0}
          >
            <Typography variant="subtitle2" color={"#A19F9D"}>
              {total_spots_available}
              <Typography
                variant="subtitle2"
                color={"black"}
                // fontWeight={"bold"}
                style={{ fontWeight: "bold" }}
              >
                {getSpotOrder && getSpotOrder.length > 10
                  ? `Spot(s):${getSpotOrder.splice(0, 10).join(", ")} ...`
                  : `Spot(s):${getSpotOrder?.join(", ")}`}
              </Typography>
              <ReservationStatus statusCode={reservation_status} />
            </Typography>
            <Typography variant="subtitle2" color={"#A19F9D"}></Typography>
          </Stack>
        </Box>
        {payment_status_code === "PENDING_PAYMENT" &&
        currentUserType === "OWNER" &&
        isMobileDeviceCheck() ? (
          <Box
            width={"35%"}
            style={{
              width: 98,
              height: 32,
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <ErrorIcon alignSelf="center" />
            <Typography
              variant="fontSize12"
              color={"red"}
              marginTop={"-5px"}
              textAlign={"center"}
            >
              {`${t("components.upcomingCard.text05")}`}
            </Typography>
            <Button
              onClick={() => {
                props?.onPressPayNow(gates);
              }}
              variant=""
              alignSelf={"center"}
              style={{
                width: "100%",
                height: 28,
                alignItems: "center",
                display: "flex",
                backgroundColor: "#f2dcdc",
              }}
            >
              <Typography
                variant="buttonText"
                color="red"
                style={{ fontWeight: "bold", fontSize: "12px" }}
              >
                {t("commonLabels.text26")}
              </Typography>
            </Button>
          </Box>
        ) : (
          <></>
        )}
      </Box>
      <Box
        onClick={() => {
          props?.onPress(gates);
        }}
      >
        <Stack alignItems="center" direction="row" spacing={0}>
          <CalenderIcon />
          <Typography sx={{ marginLeft: "5px" }} variant="fontSize12">
            {formatedtedDate}
          </Typography>
        </Stack>

        <Stack alignItems="center" direction="row" spacing={0}>
          <LocationOn
            color="#908E8D"
            style={{ fill: "#908E8D", height: "18px", width: "18px" }}
          />
          <Typography variant="subtitle2" sx={{ marginLeft: "5px" }}>
            {props?.data?.location_address_line_1}
          </Typography>
        </Stack>
      </Box>

      {isMobileDeviceCheck() &&
        (reservation_status === "CONFIRMED" ||
          reservation_status === "PNDG_EXT") && (
          <Divider flexItem sx={{ backgroundColor: "#DADADA", mt: 1 }} />
        )}

      {isMobileDeviceCheck() && (
        <GateActions
          enabled={
            reservation_status === "CONFIRMED" ||
            reservation_status === "PNDG_EXT"
          }
          openGate={props?.openGate}
          gates={gates}
        />
      )}
    </Card>
  );
};

export default UpcomingCard;
